import React from 'react';
import classes from './index.module.scss';

const OppTableHeader = ({ list, dashboard = false, checkAllHandler, isCheckAll }) => {
  return (
    <tr>
      {dashboard && (
        <th>
          <div className="Checkbox_Wrap">
            <input
              label="check"
              type="checkbox"
              name="check"
              id="check" 
              onChange={checkAllHandler}
              checked={isCheckAll}
            />
            <label htmlFor="check"></label>
          </div>
        </th>
        )}
        {list.map(item => {
          return (
            <th 
              className={classes.No_Wrap}
              key={item}
            >
              {item}
            </th>
          )
        })}
    </tr>
  )
}

export default OppTableHeader;